module.exports = __webpack_public_path__ + "img/user-2.aba067b2.svg";